import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from './utils';

export class ICompanyFTL {
  id: number;
  name: string;
  hash: string;
  company_id: number;
  group_number: number;
  price: number;
  insurance: number;
  currency_id: number;
  date: string;
  vehicleCategoriesId: number;
  micro_route_id: number;
}

export class ICompanyFTLListResponse extends IPagination {
  @Type(() => ICompanyFTL)
  results: ICompanyFTL[];
}

export class ICompanyFTLQueryDto extends IQueryPaginationDto {
  microRouteId?: string | number;
  hidden?: number;
}
